module.exports = __webpack_public_path__ + "media/images/paypal-6eaf7276475cc597d8d27e937820cbdc.png";